import { useEffect, useState } from "react";
import api, { formatFCFA } from "@/lib/api";

export default function AdminClients() {
  const [clients, setClients] = useState([]);
  useEffect(() => { api.get("/admin/clients").then((r) => setClients(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="admin-clients">
      <div>
        <h1 className="font-serif text-4xl text-[var(--dsf-green)]">Clients</h1>
        <p className="text-[var(--dsf-text-muted)] text-sm mt-1">{clients.length} clients fidèles à la maison</p>
      </div>

      <div className="bg-white border border-[var(--dsf-border)] overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-[10px] uppercase tracking-[0.18em] text-[var(--dsf-text-muted)] border-b border-[var(--dsf-border)]">
            <tr>
              <th className="text-left p-4">Client</th>
              <th className="text-left">Téléphone</th>
              <th className="text-left">Ville</th>
              <th className="text-right">Commandes</th>
              <th className="text-right">CA total</th>
              <th className="text-right p-4">Dernière cmd</th>
            </tr>
          </thead>
          <tbody>
            {clients.map((c, i) => (
              <tr key={i} className="border-b border-[var(--dsf-border)] hover:bg-[var(--dsf-sand)]" data-testid={`client-row-${i}`}>
                <td className="p-4">
                  <div className="font-medium">{c.name}</div>
                  <div className="text-xs text-[var(--dsf-text-muted)]">{c.email}</div>
                </td>
                <td className="text-xs">{c.phone}</td>
                <td className="text-xs">{c.city}</td>
                <td className="text-right font-medium">{c.orders_count}</td>
                <td className="text-right font-medium">{formatFCFA(c.total_spent)}</td>
                <td className="text-right text-xs text-[var(--dsf-text-muted)] p-4">
                  {new Date(c.last_order).toLocaleDateString("fr-FR")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {clients.length === 0 && <div className="p-12 text-center text-[var(--dsf-text-muted)]">Aucun client</div>}
      </div>
    </div>
  );
}
